// extracted by mini-css-extract-plugin
module.exports = {"ManageLottery":"styles_ManageLottery__1DM3b"};